<template>
  <div>
    <bs-page-title
      :titleLabel="fromParentTitle"
      :btnLabel="fromParentBtn"
      :btnClass="'btn-primary'"
    ></bs-page-title>
    <bs-msg-alert :alertClass="alertClass">{{
      this.alertMessage
    }}</bs-msg-alert>
    <div class="w100">
      <div class="row mb-3">
        <div class="col-4">
          <label for="Label" class="form-label">名称</label>
          <input
            type="text"
            class="form-control"
            id="Label"
            placeholder="名称"
            v-model="pref_obj.label"
          />
        </div>
        <div class="col-2">
          <label for="RegionCd" class="form-label">都道府県コード</label>
          <input
            type="text"
            class="form-control"
            id="PrefCd"
            placeholder="都道府県コード"
            v-model="pref_obj.pref_cd"
          />
        </div>
        <div class="col-4">
          <label for="RegionCd" class="form-label">地域コード</label>
          <bs-select
            :options="region_list"
            v-model="pref_obj.region_cd"
            :null-option="false"
            id="RegionCd"
            :classParam="'form-select'"
          ></bs-select>
        </div>
        <div class="col-2">
          <label for="Sort" class="form-label">sort</label>
          <input
            type="number"
            class="form-control"
            id="Sort"
            placeholder="ソート"
            v-model="pref_obj.sort"
          />
        </div>
      </div>
      <div class="mb-5"></div>
      <div class="row mb-3">
        <div class="col-12 col-sm-4 mb-2">
          <button
            type="submit"
            @click="back"
            class="btn btn-light btn-outline-secondary"
          >
            戻る
          </button>
        </div>
        <div
          class="col-12 col-sm-4 mb-2 text-center"
          v-if="chk_relation_type_editable('/master/list')"
        >
          <button type="submit" @click="update" class="btn btn-primary">
            {{ btnLabel }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import BsPageTitle from '../../molecules/BsPageTitle.vue'
import BsMsgAlert from '../../atoms/BsMsgAlert.vue'
import BsSelect from '../../atoms/BsSelect.vue'
// import BsCheckBox from '../../atoms/BsCheckBox.vue'
import config from '../../../const'

export default {
  name: 'AreaRegionDetailView',
  data: function () {
    return {
      targetid: this.$route.params.id,
      fromParentTitle: '都道府県データ',
      fromParentBtn: '',
      alertMessage: '',
      alertClass: 'alert-info',
      btnLabel: '',
      region_obj: [],
      pref_obj: {}
    }
  },
  components: {
    BsPageTitle,
    BsSelect,
    BsMsgAlert
    // BsButton,
    // BsCheckBox,
  },
  methods: {
    async loadRegionList() {
      const params = {}
      params['stat'] = [1]
      await this.basicPosts_S(
        config.BASE_API_URL + '/area_region/lists',
        params
      )
        .then(async response => {
          console.log('loadRegionList response', response)
          this.region_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log(err)
          this.region_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadPrefObj() {
      const params = {}
      params['id'] = this.targetid
      await this.basicPosts_S(config.BASE_API_URL + '/area_pref/lists', params)
        .then(async response => {
          console.log('loadPrefObj', response)
          this.pref_obj =
            response.data && response.data.body && response.data.body[0]
              ? response.data.body[0]
              : {}
        })
        .catch(async err => {
          console.log(err)
          this.pref_obj = {}
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    update() {
      console.log('component methods', this.pref_obj)
      return this.$store
        .dispatch('updateBasic', { data: this.pref_obj, target: 'area_pref' })
        .then(() => {
          this.alertMessage = this.btnLabel + 'しました'
          this.alertClass = 'alert-success'
        })
        .catch(err => {
          Promise.reject(err)
          this.alertMessage = this.btnLabel + 'できませんでした'
          this.alertClass = 'alert-danger'
        })
        .finally(async () => {
          await this.loadPrefObj()
        })
    },
    back() {
      this.$router.go(-1)
    }
  },
  computed: {
    ...mapState({}),
    region_list: function () {
      const lists = [...this.region_obj]
      return lists
        .map(list => {
          list.key = list.region_cd
          return list
        })
        .sort((a, b) => {
          if (parseInt(a.sort) < parseInt(b.sort)) {
            return -1
          } else {
            return 1
          }
        })
    }
  },

  async created() {
    await this.loadRegionList()

    if (Number.isNaN(this.targetid)) {
      this.$router.push({ path: '/' })
    } else if (this.targetid != 'add' && !Number.isNaN(this.targetid)) {
      await this.loadPrefObj()
      this.btnLabel = '更新'
    } else {
      this.pref_obj = {
        id: 0,
        label: '',
        region_cd: '',
        pref_cd: '',
        sort: 0
      }
      this.btnLabel = '登録'
    }
    this.alertMessage = this.btnLabel + 'できます'
  },
  mounted: function () {
    this.fromParentTitle = '都道府県データ詳細'
    // console.log('tags_list', this.tags_list);
  },
  props: {}
}
</script>
